import React from 'react';
import { UIUser } from 'types';
import AdditionalInfoContentBlock from './AdditionalInfoContentBlock';
import {
	generateAvailableToJoinString,
	generateCitiesComfortableWorkingInString,
	generateCompanyTypePreferencesString,
	generateCurrentSalaryString,
	generateExpectedSalaryString,
} from 'src/utils/profileAdditionalInfo';
import ProfileContentHeader from './ProfileContentHeader';

interface Props {
	title: string;
	data: UIUser;
	isAccountManagerLoggedIn: boolean;
	isSelf: boolean;
}

const AdditionalInfo = ({ title, data, isAccountManagerLoggedIn, isSelf }: Props) => {
	const availableToJoin = generateAvailableToJoinString(
		data?.profile?.isImmediateJoiner ?? data?.profile?.expectedJoining ?? '-',
	);

	const currentSalary = generateCurrentSalaryString(data.profile.currentSalary || data.profile.lastDrawnSalary || 0);
	const expectedSalary =
		data.evaluation.predictedSalary?.min || data.evaluation.predictedSalary?.max
			? generateExpectedSalaryString(
					data.evaluation.predictedSalary?.min,
					data.evaluation.predictedSalary?.min === data.evaluation.predictedSalary?.max
						? 0
						: data.evaluation.predictedSalary?.max,
			  )
			: '-';

	const companyTypePreferences = generateCompanyTypePreferencesString(data.profile.preferredCompanyTypes ?? []);
	const citiesComfortableWorkingIn =
		data.subRole === 'MasaiAlum' || data.subRole === 'MasaiStudent'
			? 'PAN India'
			: generateCitiesComfortableWorkingInString(data.profile.preferredJobLocations ?? []);
	const showJobSeekerSalary = data.flags.isMasaiStudent ? isSelf : true;

	return (
		<>
			<ProfileContentHeader data={{ name: title, isImp: false }} />
			{(availableToJoin && availableToJoin !== '-') ||
			(currentSalary && currentSalary !== '-') ||
			(expectedSalary && expectedSalary !== '-') ||
			(companyTypePreferences && companyTypePreferences !== '-') ||
			(data?.profile?.userLocation && data?.profile?.userLocation !== '-') ||
			(citiesComfortableWorkingIn && citiesComfortableWorkingIn !== '-') ? (
				<div className="flex w-full flex-col gap-2 overflow-hidden rounded-xl bg-transparent dark:bg-[#1F2A37] p-3 pb-2">
					<div className="px-2">
						<div className="flex flex-col gap-4">
							{availableToJoin && availableToJoin !== '-' ? (
								<AdditionalInfoContentBlock title="Available to join" content={availableToJoin} />
							) : null}

							{showJobSeekerSalary && currentSalary && currentSalary !== '-' ? (
								<div className="flex md:gap-[200px] sm:gap-3 sm:justify-between">
									{showJobSeekerSalary && currentSalary && currentSalary !== '-' && (
										<AdditionalInfoContentBlock
											title={data.profile.currentSalary ? 'Current Salary' : 'Last Drawn Salary'}
											content={currentSalary}
										/>
									)}

									{/* {expectedSalary && expectedSalary !== '-' && (
									<AdditionalInfoContentBlock title="Predicted salary" content={expectedSalary} />
								)} */}
								</div>
							) : null}

							{companyTypePreferences !== '-' ? (
								<AdditionalInfoContentBlock title="Company type preferences" content={companyTypePreferences} />
							) : null}

							{data?.profile?.userLocation ? (
								<AdditionalInfoContentBlock title="Current location" content={data?.profile?.userLocation || ''} />
							) : null}

							{citiesComfortableWorkingIn && citiesComfortableWorkingIn !== '-' ? (
								<AdditionalInfoContentBlock title="Preferred locations" content={citiesComfortableWorkingIn} />
							) : null}
						</div>
					</div>
				</div>
			) : (
				<div className="px-4 py-5 text-center font-inter text-[14px] font-[500] text-[#28293D] dark:text-[#C7C9D9]">
					There's nothing to show.
				</div>
			)}
		</>
	);
};

export default AdditionalInfo;
